<template>
  <el-footer class="level">
    <span class="level-left">
      <el-button type="primary" native-type="submit" :disabled="!workflowModel.isPrevStepPossible()" @click="workflowModel.changeActiveStep(-1)">
        <font-awesome-icon icon="circle-chevron-left" />
        &nbsp;
        {{ isSmallWindowSize ? '' : $t('views.customize.workflow.prevStep') }}
      </el-button>
    </span>
    <el-steps :active="workflowModel.active" finish-status="success" align-center class="level-item">
      <el-step
        v-for="step in Object.values(workflowModel.Progress)"
        :key="step"
        :title="isSmallWindowSize ? '' : $t(`enum.${workflowModel.localeIdentifier}.${step}`)"
      />
    </el-steps>
    <span class="level-right">
      <el-button
        v-if="workflowModel.activeProgressName() === workflowModel.Progress.form"
        v-loading.fullscreen.lock="fullscreenLoading"
        type="primary"
        native-type="submit"
        form="orderForm"
        :disabled="!workflowModel.isNextStepPossible()"
      >
        <el-tooltip
          :disabled="!tooltipMessage"
          placement="top"
        >
          <template #content>
            <font-awesome-icon icon="circle-exclamation" class="tooltip-warning-icon" />
            {{ tooltipMessage }}
          </template>
          <span>
            {{ isSmallWindowSize ? '' : workflowModel.isLastStep() ? $t('views.customize.workflow.lastStep') : $t('views.customize.workflow.nextStep') }}
            &nbsp;
            <font-awesome-icon icon="circle-chevron-right" />
          </span>
        </el-tooltip>
      </el-button>
      <el-button
        v-else
        v-loading.fullscreen.lock="fullscreenLoading"
        type="primary"
        native-type="submit"
        :disabled="!workflowModel.isNextStepPossible() || disabledNext"
        @click="workflowModel.OnClickNextAction(1)"
      >
        <el-tooltip
          :disabled="!tooltipMessage"
          placement="top"
        >
          <template #content>
            <font-awesome-icon icon="circle-exclamation" class="tooltip-warning-icon" />
            {{ tooltipMessage }}
          </template>
          <span>
            {{ isSmallWindowSize ? '' : workflowModel.isLastStep() ? $t('views.customize.workflow.lastStep') : $t('views.customize.workflow.nextStep') }}
            &nbsp;
            <font-awesome-icon icon="circle-chevron-right" />
          </span>
        </el-tooltip>
      </el-button>
    </span>
    <span class="totalPrice" wrap>
      <span>€</span>
      <span>{{ workflowModel.totalPrice.toFixed(2) }}</span>
    </span>
  </el-footer>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator';
import { WorkflowModel } from '@/types/ui/WorkflowModel';

@Component
export default class Workflow extends Vue {
  @Prop({ default: null }) workflowModel!: WorkflowModel<any>;
  @Prop({ default: false }) fullscreenLoading!: boolean;
  @Prop({ default: false }) disabledNext!: boolean;
  @Prop({ default: 0 }) isSmallWindowSize!: boolean;
  @Prop({ default: '' }) tooltipMessage!: string;
}
</script>

<style lang="scss" scoped>
.totalPrice {
  color: var(--color-primary);
  font-size: var(--font-size-xlarge);
  font-weight: var(--font-weight-bold);
  padding-left: 3rem;
  display: flex;
  span {
    margin-right: 0.5rem;
  }
}

@media screen and (max-width: 768px) {
  .totalPrice {
    font-size: var(--font-size-large);
    padding-left: 0.2rem;
    span {
      margin-right: 0.2rem;
    }
  }
}

.workflow {
  z-index: 0 !important;
  width: 100%;
}

.tooltip-warning-icon {
  margin-right: 2px; 
  margin-top: 2px; 
  color: #ffffff;
}
</style>
